import { render, staticRenderFns } from "./applyDetail.vue?vue&type=template&id=84b5fd14"
import script from "./applyDetail.vue?vue&type=script&lang=js"
export * from "./applyDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84b5fd14')) {
      api.createRecord('84b5fd14', component.options)
    } else {
      api.reload('84b5fd14', component.options)
    }
    module.hot.accept("./applyDetail.vue?vue&type=template&id=84b5fd14", function () {
      api.rerender('84b5fd14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/applyDetail.vue"
export default component.exports